var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-press-escape": false,
        title: "作業回別コメント",
        top: "5vh",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        width: "900px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "vab-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "div",
            { staticClass: "sure_box top_info mtn" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    {
                      staticClass: "title_box title_header",
                      attrs: { span: 24 },
                    },
                    [_vm._v(" 作業回別コメント ")]
                  ),
                ],
                1
              ),
              _vm._l(_vm.form.dataList, function (itm, idx) {
                return _c(
                  "vab-row",
                  { key: idx, staticClass: "row_box" },
                  [
                    _c(
                      "vab-col",
                      {
                        staticClass: "word_box nopadding2",
                        attrs: { span: 24 },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex_start flex_center_align" },
                          [
                            _c("p", [_vm._v(" " + _vm._s(itm.id) + "  ")]),
                            _c("vab-input", {
                              staticClass: "percentInput",
                              attrs: { prop: "dataList." + idx + ".text" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end mg12",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c("div", { staticClass: "cancel", on: { click: _vm.close } }, [
                _vm._v("キャンセル"),
              ]),
              _c("vab-button", { attrs: { "btn-list": _vm.btnList } }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }